import { MyLoadsTable } from '../views';
import {
	CAMEL_CASE,
	HQ_LOCATION_PARSER,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	TIMESTAMP_FROM_STRING,
} from '../../utils';
import { MercuryLoadDTO } from '../dtos/mercury-load-DTO';
import { GET_CARRIER_BUSINESS_NAME } from '../../carrier/utils/get-carrier-business-name';

export const HISTORICAL_LOADS_TABLE = (
	loadsList: Array<MercuryLoadDTO> = [],
	includeCountry: boolean = false
): Array<MyLoadsTable> => {
	let results: Array<MyLoadsTable> = [];
	try {
		if (loadsList.length > 0) {
			loadsList.map((load) => {
				let row = {} as MyLoadsTable;
				row.created = load.created;
				row.pickupDate = TIMESTAMP_FROM_STRING(load.pickupDate);
				row.deliveryDate = TIMESTAMP_FROM_STRING(load.deliveryDate);
				row.origin = HQ_LOCATION_PARSER(
					CAMEL_CASE(load.originCity),
					IS_NOT_EMPTY(load.originState) ? load.originState.toUpperCase() : '',
					load.originCountry,
					includeCountry
				);
				row.destination = HQ_LOCATION_PARSER(
					CAMEL_CASE(load.destinationCity),
					IS_NOT_EMPTY(load.destinationState) ? load.destinationState.toUpperCase() : '',
					load.destinationCountry,
					includeCountry
				);
				row.price = load.allInCost;
				row.priceToShipper = load.priceToShipper;
				row.trailerType = IS_NOT_EMPTY(load.equipment)
					? load.equipment.toUpperCase()
					: load.equipment;
				row.loadId = load.id;
				row.referenceNumber = load.referenceNumber;
				row.productDescription = load.commodity;
				row.totalWeight = load.weight;
				const carrier = load.carrier;
				if (IS_NOT_NULL_OR_UNDEFINED(carrier)) {
					row.carrierId = carrier.id;
					row.carrierName = GET_CARRIER_BUSINESS_NAME(
						carrier.businessName,
						carrier.doingBusinessAs
					);
				}
				row.customerName = load.customerName;
				row.predictedPrice = load.predictedPrice;

				results.push(row);
			});
		}
	} catch (error) {
		console.log('HISTORICAL_LOADS_TABLE error: ', error);
	}

	return results;
};
